


import React from "react";
import { getIn } from "formik";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";

export const RadioCorrectField = ({ field, form }) => {
  const errorText =
    getIn(form.touched, field.name) && getIn(form.errors, field.name);

  return (
    <FormControl error={!!errorText}>
      <input
        type="radio"
        style={{ transform: "scale(1.5)", cursor: "pointer" }}
        checked={field.value === true}
        onChange={() => form.setFieldValue(field.name, true)}
      />

      {errorText && (
        <Typography fontSize="10px" color="red">
          {errorText}
        </Typography>
      )}
    </FormControl>
  );
};

